import React from 'react'
import { FaFileCsv, FaTrash } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { ColorsEnum } from 'types/cssTypes'
import { kbToMb } from 'utils'
import { longTextToSmall } from 'utils/helper'

// utils & types
// components
interface IProps {
  file: File | null
  onRemoveFile: () => void
  fileStyle?: IStyle
}

interface IStyle {
  height: string
}

export const FileUploadDetails = ({ file, onRemoveFile, fileStyle }: IProps) => {
  return (
    file && (
      <Div data-testid="container" fileStyle={fileStyle}>
        <div className="file-details-container">
          <div className="file-details">
            <FaFileCsv className="csv-icon" />
            {/* <i>
                  <img src={CsvIcon} alt="CSV icon" />
                </i> */}
            <div className="file-text-container">
              <h2>{file!.name && longTextToSmall(file!.name, 15, 30)}</h2>
              <p>File Size: {kbToMb(file!.size)} MB</p>
            </div>
          </div>
          <Button
            data-testid="remove-file-btn"
            color={ColorsEnum.error}
            className="btn-remove-file"
            variant="danger-outline"
            size="small"
            radius="rounded"
            onClick={onRemoveFile}
          >
            <FaTrash /> <span>Remove File</span>
          </Button>
        </div>
      </Div>
    )
  )
}

const Div = styled.div<{ fileStyle: IStyle | undefined }>`
  width: 100%;
  height: ${({ fileStyle }) => (fileStyle?.height ? fileStyle.height : '17rem')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  color: ${({ theme }) => theme.colors.grey.neutral};
  padding: 0 ${({ theme }) => theme.spacing.l};
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  border: 1px solid ${({ theme }) => theme.colors.info.light};
  background-color: ${({ theme }) => theme.colors.info.lightest};
  h2 {
    font-weight: ${({ theme }) => theme.fontWeight.bolder};
    font-size: ${({ theme }) => theme.util.pixelToRem(24)};
    color: ${({ theme }) => theme.colors.grey.darker};
  }
  p {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: ${({ theme }) => theme.util.pixelToRem(20)};
    color: ${({ theme }) => theme.colors.grey.dark};
  }
  .btn-remove-file {
    width: 8rem;
    height: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
  }
  .file-details {
    display: flex;
    align-items: center;
    .file-text-container {
      float: left;
    }
    h2 {
      font-family: Milliard;
      font-size: 1.125rem;
      font-weight: 600;
      line-height: 1.33;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.neutral.dark};
    }
    p {
      font-family: Milliard;
      font-size: 0.875rem;
      font-weight: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.grey.dark};
    }
  }

  .file-details-container,
  .file-success-container {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    h2 {
      color: ${({ theme }) => theme.colors.grey.darker};
    }
  }
  .file-details-container {
    width: 100%;
    height: 4.5rem;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1.25rem;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    border-radius: 8px;
    box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);
    background-color: ${({ theme }) => theme.colors.neutral.lightest};
  }

  .file-details-container {
    .csv-icon {
      float: left;
      width: 2rem;
      height: 2.625rem;
      margin: 0.9375rem 1.25rem 0.9375rem 0.75rem;
      color: ${({ theme }) => theme.colors.info.neutral};
    }
    h2 {
      margin-bottom: 0.25rem;
    }
    p {
      margin-bottom: 0;
    }
  }

  .file-success-container {
    flex-direction: column;
    svg {
      margin-bottom: 0.5rem;
      color: ${({ theme }) => theme.colors.success.darker};
      display: inline-block;
    }
  }

  .file-error-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .error-icon {
      font-size: 2.5rem;
      color: ${({ theme }) => theme.colors.error.neutral};
    }
    h4 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.125rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.neutral.neutral};
      margin-top: 1rem;
      margin-bottom: 0.25rem;
    }
    p {
      font-size: 1rem;
      font-weight: normal;
      text-align: center;
      line-height: 1.5;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.grey.dark};
    }
    .missing-header {
      display: flex;
      text-align: center;
      margin-top: 24px;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      p {
        margin-right: 0.625rem;
      }
    }
  }
`
